// extracted by mini-css-extract-plugin
module.exports = {"Container":"UpdateSenha_Container__12FJ3","Error":"UpdateSenha_Error__2319J"};